import styles from './giftcard.module.scss'
import React, { useEffect, useState, useRef } from 'react'
import { compare, formatCash } from 'utils'
import moment from 'moment'

import {
  Input,
  Switch,
  Row,
  Col,
  Table,
  notification,
  Space,
  Popconfirm,
  Button,
  Select,
} from 'antd'
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons'
import GiftCardForm from './giftcard-form'
//components
import TitlePage from 'components/title-page'
import FilterDate from 'components/filter-date'
//apis
import { deleteGiftcard, getGiftcard, updateGiftcard } from 'apis/giftcard'
import { getRegions } from 'apis/region'
import { getCountries } from 'apis/country'

export default function GiftCard() {
  const typingTimeoutRef = useRef(null)
  const { Option } = Select

  const [regions, setRegions] = useState([])
  const [countGiftCard, setCountGiftCard] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [giftcards, setGiftCards] = useState([])
  const [loading, setLoading] = useState(false)
  const [valueSearch, setValueSearch] = useState('')
  const [countries, setCountries] = useState([])

  const columnsGiftCard = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      width: 50,
    },
    {
      title: 'Quốc gia',
      render: (data, record) => <div>{record.country_info && record.country_info.name}</div>,
    },
    {
      title: 'Tiêu đề',
      dataIndex: 'title',
    },
    {
      title: 'Giá bán',
      dataIndex: 'value',
      render: (data, record) => <div>{record.value || 0}</div>,
    },
    {
      title: 'Thời gian tạo',
      dataIndex: 'create_date',
      render: (data, record) => moment(record.create_date).format('DD/MM/YYYY, H:mm:ss'),
    },
    {
      title: 'Người tạo',
      dataIndex: 'employee_info',
      render: (data, record) => record.employee_info && record.employee_info.full_name,
    },
    {
      title: 'Hành động',
      render(data, record) {
        return (
          <Space>
            <Switch
              checked={data}
              onChange={(e) => _updateGiftcard(record.giftcard_id, { is_active: e })}
            />
            <Popconfirm
              onConfirm={() => _deleteGiftCard(record.giftcard_id)}
              title="Bạn có muốn xóa giftcard này không?"
            >
              <Button type="primary" icon={<DeleteOutlined />} danger />
            </Popconfirm>
          </Space>
        )
      },
    },
  ]

  const _getRegions = async (params) => {
    try {
      const res = await getRegions(params)

      if (res.status === 200) setRegions(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _updateGiftcard = async (id, body) => {
    try {
      const res = await updateGiftcard(id, body)
      if (res.status === 200) {
        _getGiftCard()
        notification.success({ message: 'Cập nhật chương trình khuyến mãi thành công' })
      } else
        notification.error({
          message:
            res.data.message || 'Cập nhật chương trình khuyến mãi thất bại, vui lòng thử lại',
        })
    } catch (e) {
      console.log(e)
    }
  }

  const onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.title = value
      else delete paramsFilter.code
      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 750)
  }

  const onFilters = (attribute = '', value = '') => {
    if (value) paramsFilter[attribute] = value
    else delete paramsFilter[attribute]
    setParamsFilter({ ...paramsFilter })
  }

  const _getGiftCard = async () => {
    try {
      setLoading(true)
      const res = await getGiftcard({ ...paramsFilter })
      if (res.status === 200) {
        setGiftCards(res.data.data)
        setCountGiftCard(res.data.count)
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const _deleteGiftCard = async (id) => {
    try {
      setLoading(true)
      const res = await deleteGiftcard([id])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa giftcard thành công' })
          _getGiftCard()
        } else notification.error({ message: 'Xóa giftcard thất bại, vui lòng thử lại' })
      } else notification.error({ message: 'Xóa giftcard thất bại, vui lòng thử lại' })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    _getGiftCard()
    _getCountries()
  }, [paramsFilter])

  return (
    <>
      <div className={`${styles['voucher_manager']} ${styles['card']}`}>
        <TitlePage title="QUẢN LÝ Giftcard" />

        <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Input
              prefix={<SearchOutlined />}
              size="large"
              placeholder="Tìm kiếm giftcard"
              onChange={onSearch}
              allowClear
              value={valueSearch}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <FilterDate
              size="large"
              paramsFilter={paramsFilter}
              setParamsFilter={setParamsFilter}
            />
          </Col>
          <Col xs={24} sm={24} md={11} lg={11} xl={7}>
            <Select
              showSearch
              size="large"
              style={{ width: '100%' }}
              name="country_id"
              enterButton
              onChange={(e) => {
                setParamsFilter({ ...paramsFilter, country_id: e })
                _getRegions({ country_id: e })
              }}
              placeholder="Lọc theo quốc gia"
              allowClear
            >
              {countries.map((info) => (
                <Option value={info.country_id}>{info.name}</Option>
              ))}
            </Select>
          </Col>
          <GiftCardForm reloadData={_getGiftCard}>
            <Button type="primary" size="large">
              Tạo GiftCard
            </Button>
          </GiftCardForm>
        </Row>

        <div
          style={{
            width: '100%',
            marginTop: '1rem',
            border: '1px solid rgb(243, 234, 234)',
          }}
        >
          <Table
            size="small"
            rowKey="giftcard_id"
            loading={loading}
            pagination={{
              position: ['bottomLeft'],
              current: paramsFilter.page,
              defaultPageSize: 20,
              pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
              showQuickJumper: true,
              onChange: (page, pageSize) =>
                setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
              total: countGiftCard,
            }}
            columns={columnsGiftCard}
            dataSource={giftcards}
            scroll={{ y: 500 }}
          />
        </div>
      </div>
    </>
  )
}
